var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 35.5 10.4" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M34.5 1.5h-3.4a.9.9 0 0 0-.5.1 7.43 7.43 0 0 0-4.3-1.7 6.23 6.23 0 0 0-4.8 2.2A5.85 5.85 0 0 0 17.7.8 5.11 5.11 0 0 0 14 2.1a6 6 0 0 0-4.7-2A6.82 6.82 0 0 0 5 1.8c-.2-.1-.3-.2-.5-.1H1.2A1.13 1.13 0 0 0 0 2.8 1.08 1.08 0 0 0 1.1 4h2.5a2.66 2.66 0 0 0-.3 1.2c0 2.8 2.7 5.2 5.9 5.2s5.9-2.4 5.9-5.2a2.77 2.77 0 0 0-.1-.9 2.88 2.88 0 0 1 2.6-1.1 4.19 4.19 0 0 1 2.8 1 1.73 1.73 0 0 0-.1 1c0 2.8 2.7 5.2 5.9 5.2s5.9-2.4 5.9-5.2a5.85 5.85 0 0 0-.2-1.3h2.4a1.22 1.22 0 0 0 1.2-1.2 1.19 1.19 0 0 0-1-1.2zM9.3 8.1c-2 0-3.7-1.3-3.7-2.8s1.7-2.8 3.7-2.8S13 3.7 13 5.2s-1.7 2.9-3.7 2.9zm17.1 0c-2 0-3.7-1.3-3.7-2.8s1.7-2.8 3.7-2.8S30 3.7 30 5.2s-1.6 2.9-3.6 2.9z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Inspector.svg